import { styled } from "styled-components";

const BorderedTextBox = styled.div`
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.56px;
  color: ${(props) => props.theme.colors.darkColor};
  line-height: 1.42;
  width: 100%;
  height: auto;
  margin: 0;
  border: none;
  resize: none;
  min-height: 68px;
  padding: 15px;
  border: 1px solid ${(props) => props.theme.colors.borderColor};
  box-sizing: border-box;
`;

export default BorderedTextBox;
